
export enum DeviceHealthStatus {
    VERY_GOOD = "VERY GOOD",
    GOOD = "GOOD",
    SUFFICIENT = "SUFFICIENT",
    AVERAGE = "AVERAGE",
    NEED_ATTENTION = "NEED ATTENTION",
    POOR = "POOR",
    VERY_POOR = "VERY POOR",
    NO_DATA = "NO DATA",
}